import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgMastercard = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 28 18"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="#ED0006"
        d="M19.41.563c4.606 0 8.34 3.778 8.34 8.437 0 4.66-3.734 8.436-8.34 8.436A8.25 8.25 0 0 1 14 15.418a8.25 8.25 0 0 1-5.41 2.018C3.982 17.437.25 13.66.25 9 .25 4.34 3.983.564 8.59.563A8.25 8.25 0 0 1 14 2.581 8.25 8.25 0 0 1 19.41.563"
      />
      <path
        fill="#F9A000"
        d="M19.41.563c4.606 0 8.34 3.778 8.34 8.437 0 4.66-3.734 8.436-8.34 8.436A8.25 8.25 0 0 1 14 15.418 8.46 8.46 0 0 0 16.93 9 8.46 8.46 0 0 0 14 2.581 8.25 8.25 0 0 1 19.41.563"
      />
      <path
        fill="#FF5E00"
        d="M14 2.582A8.46 8.46 0 0 1 16.93 9c0 2.57-1.138 4.87-2.93 6.418A8.46 8.46 0 0 1 11.07 9c0-2.57 1.137-4.87 2.93-6.418"
      />
    </svg>
  );
};
export default SvgMastercard;
